// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEmailChangeConfirmBody = {
  requestId: string;
  code: string;
};

export type typeEmailChangeConfirmOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { email: string };
};

export type typeEmailChangeConfirmOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailChangeConfirmOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEmailChangeConfirmOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEmailChangeConfirmBody = {
  type: "object",
  properties: {
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
    code: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["requestId", "code"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEmailChangeConfirm(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEmailChangeConfirmBody);
  }

  return async function postEmailChangeConfirm(
    payload: typeEmailChangeConfirmBody,
  ): Promise<
    typeEmailChangeConfirmOutput200 | typeEmailChangeConfirmOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEmailChangeConfirm" failed before calling the network. #0d7cfd341d35`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#0d7cfd341d35" },
        },
        data: null,
      } as typeEmailChangeConfirmOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/email/change-confirm`,
      httpMethod: "POST",
      options,
    })) as typeEmailChangeConfirmOutput200 | typeEmailChangeConfirmOutput400;
  };
}
